import { render, staticRenderFns } from "./modal-mandatory-comments.vue?vue&type=template&id=2567158a&"
import script from "./modal-mandatory-comments.vue?vue&type=script&lang=js&"
export * from "./modal-mandatory-comments.vue?vue&type=script&lang=js&"
import style0 from "./modal-mandatory-comments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports